module.exports = __webpack_public_path__ + "static/media/icons-dispostion-no-contact-phone.79ac10fe.svg";